import React, { useEffect } from 'react';
import { ArrowRightEndOnRectangleIcon } from '@heroicons/react/24/outline';
import logoImage from '../../assets/logo-transparent.png';

const LogoutModal = ({ isOpen, onConfirm, onCancel }) => {
  // Close on Escape key
  useEffect(() => {
    if (!isOpen) return;
    const handler = (e) => { if (e.key === 'Escape') onCancel(); };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [isOpen, onCancel]);

  if (!isOpen) return null;

  return (
    <div
      onClick={onCancel}
      style={{
        position: 'fixed', inset: 0, zIndex: 9999,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        backgroundColor: 'rgba(15, 23, 42, 0.55)',
        backdropFilter: 'blur(4px)',
        WebkitBackdropFilter: 'blur(4px)',
        padding: '20px',
        fontFamily: "'Poppins', sans-serif",
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: '#ffffff',
          borderRadius: '20px',
          padding: '36px 32px 28px',
          width: '100%',
          maxWidth: '360px',
          boxShadow: '0 24px 60px -12px rgba(0,0,0,0.3)',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
          animation: 'logoutModalIn 0.22s cubic-bezier(0.34, 1.4, 0.64, 1)',
        }}
      >
        {/* Logo */}
        <img
          src={logoImage}
          alt="Salon"
          style={{ height: '38px', width: 'auto', objectFit: 'contain', marginBottom: '20px' }}
        />

        {/* Icon circle */}
        <div style={{
          width: '64px', height: '64px', borderRadius: '50%',
          background: 'linear-gradient(135deg, #f97316 0%, #f05a35 100%)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          marginBottom: '20px',
          boxShadow: '0 8px 24px rgba(240, 90, 53, 0.35)',
        }}>
          <ArrowRightEndOnRectangleIcon style={{ width: '30px', height: '30px', color: '#fff' }} />
        </div>

        {/* Heading */}
        <h2 style={{
          fontSize: '20px', fontWeight: 700,
          color: 'var(--gray-12, #111)', margin: '0 0 8px',
          letterSpacing: '-0.01em',
        }}>
          Leaving so soon?
        </h2>

        {/* Subtext */}
        <p style={{
          fontSize: '14px', color: 'var(--gray-10, #6b7280)',
          margin: '0 0 28px', lineHeight: 1.55,
        }}>
          You'll need to sign back in to access your account and bookings.
        </p>

        {/* Buttons */}
        <div style={{ display: 'flex', gap: '10px', width: '100%' }}>
          <button
            onClick={onCancel}
            style={{
              flex: 1, padding: '11px 0',
              borderRadius: '10px',
              border: '1.5px solid var(--gray-5, #e5e7eb)',
              background: 'transparent',
              fontSize: '14px', fontWeight: 600,
              color: 'var(--gray-11, #374151)',
              cursor: 'pointer',
              fontFamily: "'Poppins', sans-serif",
              transition: 'background 0.15s, border-color 0.15s',
            }}
            onMouseEnter={(e) => { e.currentTarget.style.background = 'var(--gray-2, #f9fafb)'; }}
            onMouseLeave={(e) => { e.currentTarget.style.background = 'transparent'; }}
          >
            Stay
          </button>

          <button
            onClick={onConfirm}
            style={{
              flex: 1, padding: '11px 0',
              borderRadius: '10px',
              border: 'none',
              background: 'linear-gradient(135deg, #f97316 0%, #f05a35 100%)',
              fontSize: '14px', fontWeight: 600,
              color: '#fff',
              cursor: 'pointer',
              fontFamily: "'Poppins', sans-serif",
              boxShadow: '0 4px 12px rgba(240, 90, 53, 0.4)',
              transition: 'opacity 0.15s, box-shadow 0.15s',
            }}
            onMouseEnter={(e) => { e.currentTarget.style.opacity = '0.9'; }}
            onMouseLeave={(e) => { e.currentTarget.style.opacity = '1'; }}
          >
            Log Out
          </button>
        </div>
      </div>

      <style>{`
        @keyframes logoutModalIn {
          from { opacity: 0; transform: scale(0.88) translateY(12px); }
          to   { opacity: 1; transform: scale(1)    translateY(0); }
        }
      `}</style>
    </div>
  );
};

export default LogoutModal;
